/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M14 8.5C14 8.77614 13.7761 9 13.5 9C13.2239 9 13 8.77614 13 8.5M14 8.5C14 8.22386 13.7761 8 13.5 8C13.2239 8 13 8.22386 13 8.5M14 8.5H13M19 12C19 12.7647 19 13.4675 19 14.0003C19 14.2443 19 14.3662 19.0179 14.481C19.0658 14.7889 19.2085 15.0742 19.426 15.2972C19.5071 15.3804 19.6047 15.4536 19.8 15.6001V15.6001C20.4827 16.1121 20.824 16.3681 21.0935 16.444C21.8381 16.6536 22.62 16.2626 22.899 15.5412C23 15.2801 23 14.8534 23 14.0001V10.0001C23 9.14675 23 8.72008 22.899 8.45896C22.62 7.73749 21.838 7.34654 21.0935 7.5562C20.824 7.63208 20.4826 7.88808 19.8 8.40009V8.40009C19.6047 8.54655 19.5071 8.61978 19.426 8.70294C19.2085 8.92603 19.0658 9.21131 19.0179 9.51918C19 9.63394 19 9.75598 19 10.0001C19 10.6676 19 11.3558 19 12Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M1 11C1 8.19974 1 6.79961 1.54497 5.73005C2.02433 4.78924 2.78924 4.02433 3.73005 3.54497C4.79961 3 6.19974 3 9 3H11C13.8003 3 15.2004 3 16.27 3.54497C17.2108 4.02433 17.9757 4.78924 18.455 5.73005C19 6.79961 19 8.19974 19 11V13C19 15.8003 19 17.2004 18.455 18.27C17.9757 19.2108 17.2108 19.9757 16.27 20.455C15.2004 21 13.8003 21 11 21H9C6.19974 21 4.79961 21 3.73005 20.455C2.78924 19.9757 2.02433 19.2108 1.54497 18.27C1 17.2004 1 15.8003 1 13V11Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<rect
				opacity="0.12"
				x="1"
				y="3"
				width="18"
				height="18"
				rx="5"
				fill="currentColor"
			/>
			<path
				d="M14 8.5C14 8.77614 13.7761 9 13.5 9C13.2239 9 13 8.77614 13 8.5M14 8.5C14 8.22386 13.7761 8 13.5 8C13.2239 8 13 8.22386 13 8.5M14 8.5H13M19 15.0001L19.16 15.1201C20.3959 16.047 21.0139 16.5105 21.5312 16.4998C21.9813 16.4904 22.4035 16.2793 22.681 15.9248C23 15.5175 23 14.745 23 13.2001V10.8001C23 9.25514 23 8.48267 22.681 8.0753C22.4035 7.7208 21.9813 7.50973 21.5312 7.50038C21.0139 7.48963 20.3959 7.95312 19.16 8.88011L19 9.00009V15.0001ZM9 21H11C13.8003 21 15.2004 21 16.27 20.455C17.2108 19.9757 17.9757 19.2108 18.455 18.27C19 17.2004 19 15.8003 19 13V11C19 8.19974 19 6.79961 18.455 5.73005C17.9757 4.78924 17.2108 4.02433 16.27 3.54497C15.2004 3 13.8003 3 11 3H9C6.19974 3 4.79961 3 3.73005 3.54497C2.78924 4.02433 2.02433 4.78924 1.54497 5.73005C1 6.79961 1 8.19974 1 11V13C1 15.8003 1 17.2004 1.54497 18.27C2.02433 19.2108 2.78924 19.9757 3.73005 20.455C4.79961 21 6.19974 21 9 21Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M0.25 11.5C0.25 8.46942 0.25 6.95412 0.784817 5.77376C1.38557 4.44786 2.44786 3.38557 3.77376 2.78482C4.95412 2.25 6.46942 2.25 9.5 2.25L12.0532 2.25C12.7003 2.25 13.0238 2.25 13.2965 2.27494C16.1784 2.53853 18.4615 4.82162 18.7251 7.7035C18.75 7.97618 18.75 8.29972 18.75 8.94679C18.75 9.00636 18.75 9.03614 18.7524 9.05325C18.7789 9.24448 19.003 9.33472 19.1547 9.21528C19.1682 9.20459 19.1889 9.18312 19.2302 9.14018L19.3056 9.06178C20.1356 8.19851 20.5506 7.76687 20.8641 7.61201C21.9343 7.08322 23.2264 7.60366 23.6314 8.72661C23.75 9.05548 23.75 9.65428 23.75 10.8519L23.75 13.1482C23.75 14.3458 23.75 14.9446 23.6314 15.2734C23.2264 16.3964 21.9343 16.9168 20.8641 16.388C20.5507 16.2332 20.1356 15.8015 19.3056 14.9383L19.2302 14.8599C19.1889 14.8169 19.1682 14.7955 19.1547 14.7848C19.003 14.6653 18.7789 14.7556 18.7524 14.9468C18.75 14.9639 18.75 14.9937 18.75 15.0533C18.75 15.7003 18.75 16.0238 18.7251 16.2964C18.4615 19.1784 16.1784 21.4615 13.2964 21.7251C13.0238 21.75 12.7003 21.75 12.0533 21.75H9.5C6.46942 21.75 4.95412 21.75 3.77376 21.2152C2.44786 20.6144 1.38557 19.5521 0.784817 18.2262C0.25 17.0459 0.25 15.5306 0.25 12.5L0.25 11.5ZM13.5 9C14.3284 9 15 8.32843 15 7.5C15 6.67157 14.3284 6 13.5 6C12.6716 6 12 6.67157 12 7.5C12 8.32843 12.6716 9 13.5 9Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M19 15V15C19 15.929 19 16.3935 18.9384 16.7822C18.5996 18.9216 16.9216 20.5996 14.7822 20.9384C14.3935 21 13.929 21 13 21H9C6.19974 21 4.79961 21 3.73005 20.455C2.78924 19.9757 2.02433 19.2108 1.54497 18.27C1 17.2004 1 15.8003 1 13V9.5C1 8.10547 1 7.40821 1.13815 6.83277C1.57707 5.00453 3.00453 3.57707 4.83277 3.13815C5.40821 3 6.10547 3 7.5 3V3H8M19 15L19.16 15.12C20.3959 16.047 21.0139 16.5105 21.5312 16.4997C21.9813 16.4904 22.4035 16.2793 22.681 15.9248C23 15.5174 23 14.745 23 13.2V10.8001C23 9.25514 23 8.48267 22.681 8.0753C22.4035 7.7208 21.9813 7.50973 21.5312 7.50038C21.0139 7.48963 20.3959 7.95312 19.16 8.88011L19 9.00009M19 15V9.00009M12 3H12.5H12.9999C13.929 3 14.3935 3 14.7822 3.06157C16.9216 3.40045 18.5996 5.07835 18.9384 7.21776C19 7.60646 19 8.071 19 9.00009V9.00009M14 8.5C14 8.77614 13.7761 9 13.5 9C13.2239 9 13 8.77614 13 8.5M14 8.5C14 8.22386 13.7761 8 13.5 8C13.2239 8 13 8.22386 13 8.5M14 8.5H13"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M14 8.5C14 8.77614 13.7761 9 13.5 9C13.2239 9 13 8.77614 13 8.5M14 8.5C14 8.22386 13.7761 8 13.5 8C13.2239 8 13 8.22386 13 8.5M14 8.5H13M19 15.0001L19.16 15.1201C20.3959 16.047 21.0139 16.5105 21.5312 16.4998C21.9813 16.4904 22.4035 16.2793 22.681 15.9248C23 15.5175 23 14.745 23 13.2001V10.8001C23 9.25514 23 8.48267 22.681 8.0753C22.4035 7.7208 21.9813 7.50973 21.5312 7.50038C21.0139 7.48963 20.3959 7.95312 19.16 8.88011L19 9.00009V15.0001ZM9 21H11C13.8003 21 15.2004 21 16.27 20.455C17.2108 19.9757 17.9757 19.2108 18.455 18.27C19 17.2004 19 15.8003 19 13V11C19 8.19974 19 6.79961 18.455 5.73005C17.9757 4.78924 17.2108 4.02433 16.27 3.54497C15.2004 3 13.8003 3 11 3H9C6.19974 3 4.79961 3 3.73005 3.54497C2.78924 4.02433 2.02433 4.78924 1.54497 5.73005C1 6.79961 1 8.19974 1 11V13C1 15.8003 1 17.2004 1.54497 18.27C2.02433 19.2108 2.78924 19.9757 3.73005 20.455C4.79961 21 6.19974 21 9 21Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M0.25 11.5V12.5C0.25 15.5306 0.25 17.0459 0.784817 18.2262C1.38557 19.5521 2.44786 20.6144 3.77376 21.2152C4.95412 21.75 6.46942 21.75 9.5 21.75C12.5306 21.75 14.0459 21.75 15.2262 21.2152C16.5521 20.6144 17.6144 19.5521 18.2152 18.2262C18.75 17.0459 18.75 15.5306 18.75 12.5V11.5C18.75 8.46942 18.75 6.95412 18.2152 5.77376C17.6144 4.44786 16.5521 3.38557 15.2262 2.78482C14.0459 2.25 12.5306 2.25 9.5 2.25C6.46942 2.25 4.95412 2.25 3.77376 2.78482C2.44786 3.38557 1.38557 4.44786 0.784817 5.77376C0.25 6.95412 0.25 8.46942 0.25 11.5Z"
				fill="currentColor"
			/>
			<path
				d="M23.75 10.6465C23.75 9.61944 23.75 9.10591 23.6625 8.81982C23.2899 7.6023 21.8895 7.03829 20.7771 7.65768C20.5157 7.80322 20.1598 8.1734 19.4479 8.91374C19.3106 9.05656 19.2419 9.12796 19.1824 9.20304C18.943 9.50523 18.796 9.87018 18.7592 10.254C18.75 10.3493 18.75 10.4484 18.75 10.6465V13.3536C18.75 13.5517 18.75 13.6508 18.7592 13.7461C18.796 14.1299 18.943 14.4948 19.1824 14.797C19.2419 14.8721 19.3106 14.9435 19.4479 15.0863C20.1598 15.8267 20.5157 16.1968 20.7771 16.3424C21.8895 16.9617 23.2899 16.3977 23.6625 15.1802C23.75 14.8941 23.75 14.3806 23.75 13.3536V10.6465Z"
				fill="currentColor"
			/>
			<path
				d="M13.5 9C14.3284 9 15 8.32843 15 7.5C15 6.67157 14.3284 6 13.5 6C12.6716 6 12 6.67157 12 7.5C12 8.32843 12.6716 9 13.5 9Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
